const SUPERMEMORY_API = "https://api.supermemory.ai";
const API_KEY = process.env.REACT_APP_SUPERMEMORY_API_KEY;

const headers = {
  Authorization: `Bearer ${API_KEY}`,
  "Content-Type": "application/json",
};

/**
 * Save an inspection record to Supermemory.
 */
export async function saveInspection(machineId, record, technicianId = "default") {
  const res = await fetch(`${SUPERMEMORY_API}/v3/documents`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      content: record.content,
      containerTag: `machine-${machineId}`,
      metadata: {
        machineId,
        technicianId,
        date: record.date,
        type: "inspection",
        outcome: extractOutcome(record.content),
      },
    }),
  });

  if (!res.ok) {
    console.error("Supermemory save failed:", res.status, await res.text());
    return null;
  }

  return res.json();
}

/**
 * Search inspections using semantic search.
 */
export async function searchInspections(query, machineId = null) {
  const body = {
    q: query,
    searchMode: "hybrid",
    limit: 20,
    threshold: 0.3,
  };

  if (machineId) {
    body.containerTag = `machine-${machineId}`;
  }

  const res = await fetch(`${SUPERMEMORY_API}/v4/search`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    console.error("Supermemory search failed:", res.status, await res.text());
    return [];
  }

  const data = await res.json();

  return (data.results || []).map(r => ({
    date: r.metadata?.date || "Unknown",
    content: r.chunk || r.memory || "",
    similarity: r.similarity,
    metadata: r.metadata,
  }));
}

/**
 * Machine profile (AI context)
 */
export async function getMachineProfile(machineId) {
  const res = await fetch(`${SUPERMEMORY_API}/v4/profile`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      containerTag: `machine-${machineId}`,
    }),
  });

  if (!res.ok) {
    console.error("Supermemory profile failed:", res.status, await res.text());
    return null;
  }

  return res.json();
}

/**
 * Load all inspections
 */
export async function loadMachineHistory(machineId) {
  return searchInspections("inspection", machineId);
}

// Extract inspection outcome
function extractOutcome(content) {
  const failMatch = content.match(/FAIL: (.+)/);
  if (failMatch && failMatch[1].trim() !== "none") return "FAIL";

  const monMatch = content.match(/MONITOR: (.+)/);
  if (monMatch && monMatch[1].trim() !== "none") return "MONITOR";

  return "PASS";
}